(function($){
  
$(document).ready(function(){
   
    $('.details-plus').click(function () {
      $('.details-plus').addClass("out");
      $('.details-minus').removeClass("out");
      $('.details-data').removeClass("oculto");
    });  
    
    $('.details-minus').click(function () {
      $('.details-minus').addClass("out");
      $('.details-plus').removeClass("out");
      $('.details-data').addClass("oculto");
    });
    
    $('.delivery-plus').click(function () {
      $('.delivery-plus').addClass("out");
      $('.delivery-minus').removeClass("out");
      $('.delivery-data').removeClass("oculto");
    });  
    
    $('.delivery-minus').click(function () {
      $('.delivery-minus').addClass("out");
      $('.delivery-plus').removeClass("out");
      $('.delivery-data').addClass("oculto");
    });

  });
})(jQuery);

let faqInfo = document.querySelectorAll('.faq__info');
if(faqInfo){
  for (let i = 0; i < faqInfo.length; i++) {
    faqInfo[i].addEventListener("click", function() {
      let firstElem = faqInfo[i].firstElementChild
      let faqArrow = firstElem.lastElementChild;
      faqArrow.classList.toggle("rotate");
      let faqData = faqInfo[i].lastElementChild; 
      faqData.classList.toggle("fuera");
    });
  }
}

let forgotPass = document.querySelector('.forgotPassword');
let logIn = document.querySelector('.login');
let forgot = document.querySelector('.forgot');
if (forgotPass) {
  forgotPass.addEventListener("click", function(){
    logIn.classList.add("fuera");
    forgot.classList.remove("fuera");
  });  
}

let ordersButton = document.querySelector('.orders');
let detailsButton = document.querySelector('.details');
let addressesButton = document.querySelector('.addresses');
let editButton = document.querySelector('.edit');
let accountOrders = document.querySelector('.account__orders');
let accountDetails = document.querySelector('.account__details');
let accountAddresses = document.querySelector('.account__addresses');
if (ordersButton) {
  ordersButton.addEventListener("click", function(){
    accountOrders.classList.remove("fuera");
    accountDetails.classList.add("fuera");
    accountAddresses.classList.add("fuera");
    ordersButton.classList.add("bold");
    detailsButton.classList.remove("bold");
    addressesButton.classList.remove("bold");
  });
}
if (detailsButton) {
  detailsButton.addEventListener("click", function(){
    accountDetails.classList.remove("fuera");
    accountOrders.classList.add("fuera");
    accountAddresses.classList.add("fuera");
    detailsButton.classList.add("bold");
    ordersButton.classList.remove("bold");
    addressesButton.classList.remove("bold");
  });
}
if (addressesButton) {
  addressesButton.addEventListener("click", function(){
    showAddresses();
  });
  editButton.addEventListener("click", function(){
    showAddresses();
  });
}
function showAddresses(){
    accountAddresses.classList.remove("fuera");
    accountOrders.classList.add("fuera");
    accountDetails.classList.add("fuera");
    addressesButton.classList.add("bold");
    ordersButton.classList.remove("bold");
    detailsButton.classList.remove("bold");
}
let editAddress = document.querySelectorAll('.editAddressBtn')
let adressContainer = document.querySelectorAll('.addresses__container')
if(editAddress){
  for (let i = 0; i < editAddress.length; i++) {
    editAddress[i].addEventListener("click", function() {
      for (let i = 0; i < adressContainer.length; i++) {
        adressContainer[i].classList.add("fuera")
      }
    });
  }
}
let cancelBtn = document.querySelectorAll('.cancelBtn')
if(cancelBtn){
  for (let i = 0; i < cancelBtn.length; i++) {
    cancelBtn[i].addEventListener("click", function() {
      if(adressContainer){
        for (let i = 0; i < adressContainer.length; i++) {
          adressContainer[i].classList.remove("fuera")
        }     
      }
    });
  }
}

if (window.innerWidth < 950){
    $(".home-video-small").removeClass("fuera")
    $(".home-video").addClass("fuera")
}
function videoHomeResize() {
  if (window.innerWidth < 950){
    $(".home-video-small").removeClass("fuera")
    $(".home-video").addClass("fuera")
  }else{
    $(".home-video-small").addClass("fuera")
    $(".home-video").removeClass("fuera")
  }
}
window.onresize = videoHomeResize;

$('#shopify-section-1663760517d283d5f6 .grid-uniform').slick({
  dots: true,
  infinite: true,
  speed: 1200,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 850,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
